'use-client';
import * as React from 'react';
import type {
  QuickActionBarProps,
  QuickActionBarSkinProps,
  SkinComponent,
} from '../../../QuickActionBar.types';
import BaseFixedSkin from '../BaseFixedSkin';
import QuickActionBar from '../../QuickActionBar';
import styles from './styles/RectSkin.scss';

export const RectSkinComp: React.ForwardRefRenderFunction<
  never,
  QuickActionBarSkinProps
> = (props, ref) => <BaseFixedSkin {...props} ref={ref} />;

const RectSkin: React.FC<QuickActionBarProps> = props => {
  return (
    <QuickActionBar
      {...props}
      skin={React.forwardRef(RectSkinComp) as SkinComponent}
      skinStyles={styles}
    />
  );
};

export default RectSkin;
